import script from "./NotificationsInbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsInbox.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationsInbox.vue?vue&type=style&index=0&id=3458ecc5&lang=scss"

const __exports__ = script;

export default __exports__